import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../../spinner";
import axios from "axios";
import { Mensaje } from "../../mensajes2";
import { Toasts } from "../../toasts";
import useTable from "../../useTable";
import CatalogoFabricantes from "../../../catalogos/catalogoFabricantes";

import { PrimaryButton } from "../../../ui/buttons/Button";
var op = require("../../../modulos/datos");

const headCells = [
  {
    id: "idunidadmedida",
    label: "CODIGO",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION",
    width: "440px",
    textAlign: "left",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "OPCIONES",
    width: "180px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

export const GestionarFabricantes = (props) => {
  const permiso = "1111";
  const txtBuscador = useRef();
  const afiliado = JSON.parse(localStorage.getItem("riforganizacion"));
  const token = localStorage.getItem("jwtToken");
  const [catalogoModelo, setCatalogoModelo] = useState(false);
  const [fabricante, setFabricante] = useState();
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState();
  const [records, setRecords] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const seleccionarRegistros = () => {
    const campos = "*";
    const nomtab = "fabricante";
    const orden = "idfabricante";

    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
        txtBuscador.current?.focus();
      });
  };
  const imprimirFabricantes = () => {
    window.open(
      `${op.reportes}/comprasyalmacen?afiliado=${afiliado}&reporte=ListFabricantes`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idfabricante
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const cerrar = () => {
    blanquear();
    if (props.onHideCancelar) props.onHideCancelar();
    if (props.setShow) props.setShow(false);
    props.cerrar();
  };
  const cerrarModal = () => {
    if (props.onHideCancelar) {
      props.onHideCancelar();
    }
    if (props.setShow) props.setShow(false);

    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.cerrar();
  };
  const blanquear = () => {
    setActivate(false);
    setFabricante();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
        txtBuscador.current?.focus();
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Gestionar Fabricantes.</h3>
        <a type="button" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={activate} inverted></Dimmer>
      <div className="col-12">
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-4 m-0 p-0">
            <div className="w-100 m-0 p-0 input-group input-group-sm text-uppercase">
              <input
                type={"text"}
                className="form-control text-uppercase"
                onChange={handleSearch}
                placeholder="Buscar Fabricantes..."
                ref={txtBuscador}
              />
              <button
                className="btn btn-sm btn-info"
                onClick={imprimirFabricantes}
              >
                <i className="fas fa-print m-0" />
              </button>
            </div>
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton
              className="btn btn-sm btn-info"
              icon="fa-plus m-0"
              onClick={() => {
                setFabricante();
                setCatalogoModelo(true);
                setOperacion(1);
              }}
            />
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={item.idunidadmedida} style={{ padding: "0" }}>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "10px",
                      }}
                    >
                      {item.idfabricante}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      className="mx-auto"
                      align="center"
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "120px",
                      }}
                    >
                      <button
                        onClick={() => {
                          setFabricante(item);
                          setCatalogoModelo(true);
                          setOperacion(4);
                        }}
                        className={
                          permiso.toString().substring(0, 1) === "1"
                            ? "btn btn-sm btn-info rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={() => {
                          setFabricante(item);
                          setCatalogoModelo(true);
                          setOperacion(2);
                        }}
                        className={
                          permiso.toString().substring(2, 3) === "1"
                            ? "btn btn-sm btn-warning rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={() => {
                          setFabricante(item);
                          setCatalogoModelo(true);
                          setOperacion(3);
                        }}
                        className={
                          permiso.toString().substring(3, 4) === "1"
                            ? "btn btn-sm btn-danger rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fa fa-trash-alt"></i>{" "}
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </div>
      <CatalogoFabricantes
        show={catalogoModelo}
        fabricante={fabricante}
        onHideCancelar={() => setCatalogoModelo(false)}
        onHideRenderizar={seleccionarRegistros}
        operacion={operacion}
      />
    </Modal>
  );
};
